<form [formGroup]="form" class="form__table__dynamic-input"
  [class.form__table__dynamic-input--dropdown]="type === EnumTableDynamicInputType.DROPDOWN || type === EnumTableDynamicInputType.MULTI_DROPDOWN"
  [class.form__table__dynamic-input--multi-dropdown]="type === EnumTableDynamicInputType.MULTI_DROPDOWN"
  [class.form__table__dynamic-input--readonly]="readOnly">
  @switch (type) {
    @case ("email") {
      <mat-form-field appearance="outline" class="table__dynamic-input">
        <input matInput formControlName="control" type="email" [placeholder]="placeholderText()"
          (mousedown)="onControlMouseDown($event)" />
      </mat-form-field>
      @if(control.invalid && (control.touched || control.dirty)) {
        <div class="field-error">
          @if(control.errors?.['required']) {
            {{ t('requiredField') }}
          } @else {
            {{ t('invalidEmail') }}
          }
        </div>
      }
    }
    @case (EnumTableDynamicInputType.DROPDOWN) {
      <mat-form-field appearance="outline" class="table__dynamic-input table__dynamic-input--dropdown">
        <mat-select formControlName="control"
          [placeholder]="selectPlaceholderText()"
          panelClass="table-role-select-panel"
          [panelWidth]="null"
          [disableOptionCentering]="true"
          (mousedown)="onControlMouseDown($event)">
          @for (option of options; track option) {
            <mat-option [value]="option">{{ optionLabel(option) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if(required && control.invalid && (control.touched || control.dirty)) {
        <div class="field-error">{{ t('requiredField') }}</div>
      }
    }
    @case (EnumTableDynamicInputType.MULTI_DROPDOWN) {
      <mat-form-field appearance="outline" class="table__dynamic-input table__dynamic-input--dropdown table__dynamic-input--multi">
        <mat-select formControlName="control"
          multiple
          [placeholder]="selectPlaceholderText()"
          panelClass="table-allowed-actions-panel"
          [panelWidth]="null"
          [disableOptionCentering]="true"
          (mousedown)="onControlMouseDown($event)"
          (selectionChange)="onMultiDropdownChange($event)">
          <mat-select-trigger>
            {{ multiSelectTriggerLabel(control.value) }}
          </mat-select-trigger>
          @for (option of options; track option) {
            <mat-option [value]="option">{{ optionLabel(option) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if(required && control.invalid && (control.touched || control.dirty)) {
        <div class="field-error">{{ t('requiredField') }}</div>
      }
    }
    @case ("tel") {
      <div class="phone-input-block">
        <div class="phone-input-row">
          <mat-form-field appearance="outline" class="table__dynamic-input country-select-field">
            <mat-select
              class="country-select"
              [value]="selectedCountry"
              (selectionChange)="onCountrySelect($event.value)"
              (openedChange)="onCountryPanelOpened($event)"
              (mousedown)="onControlMouseDown($event)"
              panelClass="country-select-panel"
              [disableOptionCentering]="true"
            >
              <mat-select-trigger>
                <span class="country-option">
                  <span class="country-flag">{{ selectedCountry.flag }}</span>
                  <span class="country-code">{{ selectedCountry.dialCode }}</span>
                </span>
              </mat-select-trigger>
              <mat-option class="country-search-option" disabled>
                <input
                  matInput
                  type="text"
                  [placeholder]="searchPlaceholderText()"
                  [formControl]="countrySearchControl"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()"
                />
              </mat-option>
              @for (country of filteredCountryOptions; track country.iso2) {
                <mat-option [value]="country">
                  <span class="country-option">
                    <span class="country-flag">{{ country.flag }}</span>
                    <span class="country-name">{{ country.name }}</span>
                    <span class="country-code">{{ country.dialCode }}</span>
                  </span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="table__dynamic-input phone-number-field">
            <input matInput formControlName="control" type="tel" [placeholder]="placeholderText()"
              (mousedown)="onControlMouseDown($event)" />
          </mat-form-field>
        </div>
        @if(required && control.invalid && (control.touched || control.dirty)) {
          <div class="field-error phone-input-block__error">{{ t('requiredField') }}</div>
        }
      </div>
    }
    @default {
      <mat-form-field appearance="outline" class="table__dynamic-input">
        <input matInput formControlName="control" type="text" [placeholder]="placeholderText()"
          (mousedown)="onControlMouseDown($event)" />
      </mat-form-field>
      @if(required && control.invalid && (control.touched || control.dirty)) {
        <div class="field-error">{{ t('requiredField') }}</div>
      }
    }
  }
</form>
